export enum Level {
    CHAPTER_ONE,
    CHAPTER_TWO
}